import React from 'react'

import { useQuery } from '@apollo/react-hooks'
import { ALL_USERS } from './queries'
import {
  Grid,
  CircularProgress,
  Typography,
  Box,
  makeStyles
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import UserTabs from './UserTabs'

const useStyles = makeStyles((_theme) => ({}))

function ManageUsers(props) {
  const classes = useStyles()
  const history = useHistory()
  const { data, loading, error } = useQuery(ALL_USERS, {
    // pollInterval: 1000
  })

  if (props.userProfile !== 'administrator') {
    history.replace('/admin/surveys')
  }

  if(error) {
    return (
      <Typography>
        { error.message }
      </Typography>
    )
  }

  if (loading) {
    return (
      <Grid container justify="center" alignItems="center">
        <Grid item>
          <Box mt={ 25 }>
            <CircularProgress />
          </Box>
        </Grid>
      </Grid>
    )
  }

  return (
    <UserTabs
      data={ data.allUsers }
    />
  )
}

export default ManageUsers
